export default "__VITE_ASSET__c9fdb32a__"